import { AbortedError } from '@orus.eu/error'

export type SleepParams = {
  /** The abort signal */
  signal?: AbortSignal | undefined
  /**
   * The jitter ratio to add to the sleep duration, between 0 and 1.
   *
   * For example, if `jitterRatio` is 0.1, the sleep duration will be between `ms` and `ms * 1.1`.
   */
  jitterRatio?: number
}

export async function sleep(ms: number, params: SleepParams = {}): Promise<void> {
  const { signal, jitterRatio } = params

  const jitterMs = jitterRatio ? Math.random() * jitterRatio * ms : 0

  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      return reject(signal?.reason ?? new AbortedError('Sleep already has signal aborted'))
    }
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort)
      resolve()
    }, ms + jitterMs)

    signal?.addEventListener('abort', onAbort, { once: true })

    function onAbort() {
      clearTimeout(timer)
      reject(signal?.reason ?? new AbortedError('Sleep has been aborted'))
    }
  })
}
